import Seo from "@/components/Seo";
import Header from "@/components/landing/Header";
import IndustryStrip from "@/components/landing/IndustryStrip";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Calculator from "@/components/landing/Calculator";
import HowItWorks from "@/components/landing/HowItWorks";
import DemoVideo from "@/components/landing/DemoVideo";
import TryIt from "@/components/landing/TryIt";
import Pipeline from "@/components/landing/Pipeline";
import WeeklyReport from "@/components/landing/WeeklyReport";
import Bento from "@/components/landing/Bento";
import Testimonials from "@/components/landing/Testimonials";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import LeadForm from "@/components/landing/LeadForm";
import Footer from "@/components/landing/Footer";

export default function TradePage({ trade }) {
  return (
    <>
      <Seo title={trade.seo.title} description={trade.seo.description} />
      <Header />
      <IndustryStrip />
      <main>
        <Hero content={trade.hero} />
        <Marquee />
        <Calculator
          stats={trade.stats}
          defaultMissed={trade.defaultMissed}
          defaultTicket={trade.defaultTicket}
          ticketMax={trade.ticketMax}
          ticketStep={trade.ticketStep}
        />
        <HowItWorks chat={trade.chat} />
        <DemoVideo />
        <TryIt />
        <Pipeline />
        <WeeklyReport />
        <Bento />
        <Testimonials />
        <Pricing />
        <FAQ />
        <LeadForm source={trade.source} />
      </main>
      <Footer />
    </>
  );
}
